module.exports = __webpack_public_path__ + "img/reClock.80027c53.svg";